export interface ErrorPayload {
  desc: string;
  errorType?: string;
  statusCode?: number;
}

export function isCreditsErrorPayload(error: ErrorPayload): boolean {
  return (
    error.statusCode === 402 ||
    (error.errorType === 'http_status_code' && /\b402\b/.test(error.desc)) ||
    /402 Payment Required/i.test(error.desc)
  );
}
